import { render, staticRenderFns } from "./tokenPayout.vue?vue&type=template&id=ebaabeba&"
import script from "./tokenPayout.vue?vue&type=script&lang=js&"
export * from "./tokenPayout.vue?vue&type=script&lang=js&"
import style0 from "./tokenPayout.vue?vue&type=style&index=0&id=ebaabeba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports